import React, { useState } from "react";
import { toast } from "react-toastify";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";

import { i18n } from "../../translate/i18n";
import ButtonWithSpinner from "../ButtonWithSpinner";
import { validateCompletionDescription, buildCompleteTaskPayload } from "../../pages/Tasks/taskUtils";

// Diálogo de confirmação para concluir a tarefa — descrição de conclusão é
// opcional (máx. 5000). Bloqueia fechamento por ESC/clique fora e duplo
// envio enquanto `saving`; permanece aberto se a ação falhar.
const TaskCompleteDialog = ({ open, onClose, onConfirm }) => {
  const [completionDescription, setCompletionDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const [fieldError, setFieldError] = useState(null);

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  const handleConfirm = async () => {
    const error = validateCompletionDescription(completionDescription);
    if (error) {
      setFieldError(error);
      return;
    }

    setSaving(true);
    const payload = buildCompleteTaskPayload({ completionDescription });
    const success = await onConfirm(payload);
    setSaving(false);

    if (success) {
      toast.success(i18n.t("tasks.details.actions.completeSuccess"));
      setCompletionDescription("");
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="task-complete-dialog-title"
      disableBackdropClick={saving}
      disableEscapeKeyDown={saving}
    >
      <DialogTitle id="task-complete-dialog-title">
        {i18n.t("tasks.details.actions.completeTitle")}
      </DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>{i18n.t("tasks.details.actions.completeConfirm")}</Typography>
        <TextField
          label={i18n.t("tasks.details.actions.completionDescription")}
          variant="outlined"
          size="small"
          fullWidth
          multiline
          minRows={3}
          value={completionDescription}
          onChange={e => {
            setCompletionDescription(e.target.value);
            setFieldError(null);
          }}
          error={Boolean(fieldError)}
          helperText={
            fieldError ? i18n.t(`tasks.details.actions.errors.completionDescription.${fieldError}`) : ""
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={saving} color="secondary" variant="outlined">
          {i18n.t("tasks.details.actions.cancelButton")}
        </Button>
        <ButtonWithSpinner
          onClick={handleConfirm}
          color="primary"
          variant="contained"
          loading={saving}
        >
          {i18n.t("tasks.details.actions.completeConfirmButton")}
        </ButtonWithSpinner>
      </DialogActions>
    </Dialog>
  );
};

export default TaskCompleteDialog;
